
import { Component, Prop, Vue } from 'vue-property-decorator';
import SvgHomePointsPicto from '@/components/Home/SvgHomePointsPicto.vue';
import SvgHomePointsPicto2 from '@/components/Home/SvgHomePointsPicto2.vue';
import SvgHomeBackground from '@/components/Home/SvgHomeBackground.vue';
import { isConnected } from '@/services/common/common';

@Component({
  components: {
    SvgHomePointsPicto,
    SvgHomePointsPicto2,
    SvgHomeBackground,
  },
})
export default class HomePoints extends Vue {
  @Prop({ type: String, required: true })
  readonly pointsTitle!: string;

  @Prop({ type: String, required: true })
  readonly pointsSubtitle!: string;

  @Prop({ type: String, required: true })
  readonly pointsDescription!: string;

  @Prop({ type: Boolean, default: false })
  readonly noBtnBarem!: boolean;

  @Prop({ type: String, required: false, default: 'Barème de points' })
  readonly btnBaremText!: string;

  get navigateToPointsScale() {
    if (isConnected()) {
      return { name: 'scalePoints' };
    }
    return { name: 'scale-points-public' };
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get compShowStickers() {
    return !this.$store.getters['platform/getPlatform'].style.hideStickers;
  }
}
